import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';

const CTASection = ({
  title = "Ready to Secure Your Digital Assets?",
  description = "Let's discuss how our cybersecurity solutions can protect your organization.",
  primaryCTA = { text: 'Contact Sales', href: '/contact' },
  secondaryCTA,
  variant = 'default' // 'default' | 'minimal'
}) => {
  return (
    <section 
      className={`relative overflow-hidden ${
        variant === 'minimal' ? 'py-12' : 'py-16 md:py-24'
      }`}
      data-testid="cta-section"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-brand-maroon-dark via-brand-maroon to-brand-maroon-light" />
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zm20.97 0l9.315 9.314-1.414 1.414L34.828 0h2.83zM22.344 0L13.03 9.314l1.414 1.414L25.172 0h-2.83zM32 0l12.142 12.142-1.414 1.414L30 .828 17.272 13.556 15.858 12.14 28 0zm0 28.284l12.142 12.142-1.414 1.414L30 29.112 17.272 41.84l-1.414-1.414L28 28.284zm0-14.142L19.858 26.284l-1.414-1.414L30 13.728l11.556 11.142-1.414 1.414L32 14.142z' fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`
        }}
      />

      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6"
            data-testid="cta-title"
          >
            {title}
          </h2>
          <p 
            className="text-lg md:text-xl text-white/90 mb-8 md:mb-10 leading-relaxed"
            data-testid="cta-description"
          >
            {description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              asChild
              size="lg"
              variant="secondary"
              className="bg-white text-brand-maroon hover:bg-warm-gray-50 shadow-lg"
              data-testid="cta-primary-button"
            >
              <Link to={primaryCTA.href}>
                <Phone className="mr-2 w-5 h-5" />
                {primaryCTA.text}
              </Link>
            </Button>
            {secondaryCTA && (
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-white text-white hover:bg-white/10"
                data-testid="cta-secondary-button"
              >
                <Link to={secondaryCTA.href}>
                  {secondaryCTA.text}
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;